<script setup>
import { maskName } from '@/utils/index'
import { useRoute ,useRouter} from 'vue-router'
import { getSpaceDetailAPI, getSpaceListAPI } from '@/apis/user'
import { useUserStore } from '@/stores/userStore'
import GoodsItem from '@/views/Home/components/GoodsItem.vue'
import TitleComponent from '@/components/TitleComponent/index.vue'
import { setAddfollowApi, setDelfollowApi } from '@/apis/detail'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
let router = useRoute()
let route = useRouter()
const userStore = useUserStore()
const spaceList = ref([])
const loginModel = ref(false);
const noProduct = ref(false);
const param = reactive({
    userID: router.params.id,
    userDetail: {},
    listParam: {
        page: 1,
        page_size: 20,
        userId: router.params.id
    }
})
/**
 * 获取该用户详情
 */
const getuserDetail = async () => {
    const res = await getSpaceDetailAPI({ userId: param.userID, loginUserId: userStore.userInfo?.id })
    if (res.code == 0) {
        param.userDetail = res.data.userInfo
        console.log(param.userDetail)

    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
/**
 * 
 * @param value 取消关注
 */
const delfollow = (id) => {
    ElMessageBox.confirm(
        t('home32'),
        {
            cancelButtonText: t('home5'),
            confirmButtonText: t('home4'),
            type: 'warning',
        }
    )
        .then(async () => {
            const res = await setDelfollowApi({ followId: id })
            if (res.code == 0) {

                ElMessage({ type: 'success', message: t('home41') })
                userStore.getUser()
                getuserDetail()
                param.userDetail.isFollowTo = 0
            } else {
                ElMessage({ type: 'error', message: res.message })
            }
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: t("home33"),
            })
        })

}
/**
 * 
 * @param value 关注
 */
const Addfollow = async (id) => {
    if (userStore.userInfo.token) {
        const res = await setAddfollowApi({ followId: id })
        if (res.code == 0) {
            ElMessage({ type: 'success', message: t("home34") })
            userStore.getUser()
            getuserDetail()
            param.userDetail.isFollowTo = 1
        } else {
            ElMessage({ type: 'error', message: res.message })
        }
    } else {
        // 2. 跳转到登录页
        loginModel.value = true
    }


}
// 总数量
const total = ref(0)
const getSpaceList = async () => {
    const res = await getSpaceListAPI(param.listParam)
    if (res.code == 0) {
        spaceList.value = res.data.data
        total.value = res.data.total
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const loading = ref(false)
const noMore = computed(() => {
    if (spaceList.value) {
        if (spaceList.value.length >= total.value) {
            return true;
        } else {
            return false;
        }
    }
})
const disabled = computed(() => loading.value || noMore.value)
const load = () => {

    loading.value = true
    setTimeout(async () => {
        param.listParam.page++
        const res = await getSpaceListAPI(param.listParam)
        if (res.data.data) {
            spaceList.value = [...spaceList.value, ...res.data.data]
            loading.value = false
        }
    }, 100)
}
const handleClose = () => {
    loginModel.value = false
    window.location.reload();
}
const goBack = () => {
    router.go(-1);
}
const toPage=()=>{
    route.push({path:router.path})
}
onMounted(() => {
    param.userID = router.params.id
    console.log('router.params',router.path)
    if (router.query.type == '1') {
        noProduct.value = true
    }
    getuserDetail()
    getSpaceList()
});
//复制
const handleCopy = async (text) => {
    navigator.clipboard.writeText(text)
        .then(() => {
            ElMessage({ type: 'success', message: t('cart74') });
        })
        .catch(err => {
            ElMessage({ type: 'error', message: t('cart75') });
        });
}
const value = ref(4)
const drawer = ref(false)
const drawerClose = () => {
    drawer.value = false
}
</script>
<template>
    <div class="userDetailPage" :class="noProduct ? 'no-pg' : ''">
        <TitleComponent :title="''" class="phone"></TitleComponent>

        <div class="top">
            <div class="no-info" v-if="noProduct">
                <img src="../../../assets/images/nobox.png" />
                <div>{{ $t('setup462') }}{{ $t('setup463') }} </div>
            </div>
            <div class="userInfo pc">
                <div class="user">
                    <div class="userimg">
                        <img :src="param.userDetail.avatar" class="avatar">

                    </div>
                    <div class="user-info">
                        <div class="username" id="name">
                            <!-- {{ maskName(`${param.userDetail.nickname}`)}} -->
                            {{ param.userDetail.nickname }}
                        </div>
                        <div class="rating-collection">
                            <img class="el-rate-phone" src="../../../assets/images/collects1.png" srcset="">
                            <el-rate class="el-rate" style="--el-rate-disabled-icon-color: #f2cb0b;" v-model="value"
                                disabled text-color="#FC7702" />
                            <div style="padding-left: 4px;"> 4.0</div>
                            <div class="line"></div>
                            <div class="fans">{{ $t('home6') }}：<span>{{ param.userDetail.fansNum }}</span></div>
                            <div class="line"></div>
                            <div class="fans">{{ $t('home7') }}：<span>{{ param.userDetail.followPersonNum }}</span>
                            </div>
                        </div>
                        <div class="introduce" v-if="!noProduct">
                            <div>{{ param.userDetail.introduce == '' ? t('home42') : param.userDetail.introduce }}
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <div class="attention">

                            <div class="focuson" @click="Addfollow(param.userDetail.id)"
                                v-if="param.userDetail.isFollowTo == 0">
                                <img src="../../../assets/images/nofollow.png" alt="" srcset="">
                                <div>{{ $t('home7') }}</div>

                            </div>
                            <div class="nofocuson" @click="delfollow(param.userDetail.id)"
                                v-if="param.userDetail.isFollowTo == 1">
                                <div>{{ $t("home27") }}</div>
                            </div>


                        </div>
                        <div class="btn" v-if="noProduct" @click="toPage">
                            {{t('setup461')}}
                        </div>
                        <div class="btn-pc" v-if="noProduct" @click="toPage">
                            <svg-icon icon-class="dianpu" style="width: 15px;height: 14px;margin-right: 3px;" />
                            <div>{{t('setup458')}}</div>
                        </div>

                        <div class="attention-phone">
                            <div @click="Addfollow(param.userDetail.id)" v-if="param.userDetail.isFollowTo == 0">
                                <img class="focuson" src="../../../assets/images/noguanzhu.png" alt="" srcset="">

                            </div>
                            <div @click="delfollow(param.userDetail.id)" v-if="param.userDetail.isFollowTo == 1">
                                <img class="focuson" src="../../../assets/images/guanzhu.png" alt="" srcset="">
                            </div>
                        </div>
                        <div class="attention telegrams" v-if="userStore.userInfo.id != param.userDetail.id">
                            <el-tooltip :content="param.userDetail.watchApp" placement="top" effect="customized"
                                v-if="param.userDetail.watchApp">
                                <!-- <a :href="`${param.userDetail.watchApp}`" target="_blank" rel="nofollow" class="button"> -->
                                <img src="../../../assets/images/watch.png" class="telegram-icon icon1" alt=""
                                    srcset="">
                                <!-- </a> -->
                            </el-tooltip>
                            <el-tooltip :content="param.userDetail.telegram" placement="top" effect="customized"
                                v-if="param.userDetail.telegram">
                                <!-- <a :href="`${param.userDetail.telegram}`" target="_blank" rel="nofollow" class="button"  v-if="param.userDetail.telegram">-->

                                <img src="../../../assets/images/telegram.png" class="telegram-icon" srcset="">
                                <!-- </a> -->
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no-info-pc" v-if="noProduct">
                <img src="../../../assets/images/nobox-pc.png" />

                <div>
                    <div>{{ $t('setup462') }}</div>
                     <div>{{ $t('setup463') }}</div></div>
            </div>

            <div class="list">
                <div class="no-info-line" v-if="noProduct">
                    <img src="../../../assets/images/similar.png" />
                    <div>{{ $t('setup464') }}</div>
                </div>
                <div class="goods-list">
                    <div class="body" v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
                        <!-- 商品列表-->

                        <GoodsItem v-for="(lick, index) in spaceList" :key="index" :goods="lick"
                            :type="'UserDetails'" />
                        <!-- 填充，防止变形，凑满一行5个 -->
                        <div class="item-none"></div>
                        <div class="item-none"></div>
                        <div class="item-none"></div>
                        <div class="item-none"></div>

                    </div>
                    <p v-if="loading" style="text-align: center;">Loading...</p>
                    <p v-if="noMore" style="text-align: center;">No more</p>

                </div>
            </div>
        </div>
    </div>
    <el-dialog v-model="loginModel" width="350" :before-close="handleClose">
        <loginView :loginType="1" @close="handleClose" :type="1"></loginView>
    </el-dialog>
    <el-drawer v-model="drawer" :title="t('cart23')" direction="btt" :before-close="drawerClose" size="25%">
        <div>
            <div v-if="param.userDetail.telegram">
                <a :href="`${param.userDetail.telegram}`" target="_blank" rel="nofollow" class="button"
                    style="padding-right: 5px;">
                    <img src="../../../assets/images/telegram.png" style="width: 20px;height: 20px;" alt="" srcset="">
                </a>
                {{ param.userDetail.telegram }}
                <el-button type="warning" @click="handleCopy(param.userDetail.telegram)" size="small"
                    style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
            </div>
            <div style="padding-top: 20px;" v-if="param.userDetail.watchApp">
                <a :href="`${param.userDetail.watchApp}`" target="_blank" rel="nofollow" class="button"
                    style="padding-right: 5px;">
                    <img src="../../../assets/images/watch.png" style="width: 20px;height: 20px;border-radius: 50%;    "
                        alt="" srcset="">
                </a>
                {{ param.userDetail.watchApp }}
                <el-button type="warning" @click="handleCopy(param.userDetail.watchApp)" size="small"
                    style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
            </div>
        </div>
    </el-drawer>
</template>
<style scoped lang="scss">
.phone {
    display: none !important;
}

.pc {
    display: block !important;
}

.container {
    height: 41px;
}

.userDetailPage {
    // min-height: 100%;
    background-color: #F0F2F3;

    .top {
        width: 1200px;
        margin: 0 auto;
    }


    .userInfo {
        background: #fff;
        padding: 20px 30px;
        margin: 10px 0;

        .user {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .userimg {

                width: 105px;
                height: 90px;

                .avatar {
                    width: 90px;
                    /* 设置头像的宽度 */
                    height: 90px;
                    /* 设置头像的高度 */
                    border-radius: 5px;
                    /* 使头像呈现圆形 */
                }

            }

            .user-info {
                flex: 1;

                .username {
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    font-size: 16px;
                    color: #11192D;
                    line-height: 21px;
                    text-align: left;
                    font-style: normal;
                }

                .rating-collection {
                    display: flex;
                    align-items: center;
                    color: #FC7702;

                    .el-rate-phone {
                        display: none;
                    }

                    .line {
                        width: 1px;
                        height: 11px;
                        border: 1px solid #D6D6D6;
                        margin: 0 10px;
                    }

                    .fans {
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #888888;
                        line-height: 19px;
                        text-align: left;
                        font-style: normal;

                        span {
                            color: #333333;
                        }
                    }
                }
            }

            .introduce {
                padding-top: 10px;
            }



            .attention-phone {
                display: none;
            }

            .attention {
                display: flex;
                align-items: center;
                padding-left: 10px;

                .focuson,
                .nofocuson {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #f5f5f5;
                    padding: 0 38px;
                    height: 40px;
                    background: #ec4634;
                    border-radius: 20px;

                    >img {
                        width: 15px;
                        height: 15px;
                        margin-right: 6px;

                    }

                    >div {
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #fff;
                        line-height: 19px;
                        text-align: left;
                        font-style: normal;
                    }

                    // font-weight: 600;
                }

                .focuson {
                    border: 1px solid #E1E1E1;
                    background: #FFFFFF;

                    >div {
                        color: #11192D;
                    }

                }

            }

            .telegram-icon {
                width: 40px;
                height: 40px;
                border-radius: 50%;
            }

            .icon1 {
                margin-right: 10px;
            }

        }
    }







    .list {
        height: 100%;
        background: #fff;

        padding: 25px 18px;
        margin-bottom: 20px;
        .no-info-line{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-family: PingFangSC, PingFang SC;
                font-weight: bold;
                font-size: 18px;color: #11192D;
                line-height: 15px;
                font-style: normal;
                padding-top: 10px;
                padding-bottom: 20px;
                >img{
                    display: none;
                }
            }
        .goods-list {

            .body {

                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;

                .item-none {
                    width: 20%;

                }
            }
        }
    }
}

.no-info {
    display: none;
}
.no-info-pc{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #E1E1E1;;
    >img{
        width: 120px;
        height: 96px;
        margin-right: 20px;
    }
    >div{
font-family: MicrosoftYaHei, MicrosoftYaHei;
font-weight: bold;
font-size: 16px;
color: #333333;
line-height: 21px;
text-align: left;
font-style: normal;
    }
}
.no-pg {
    background-color: #fff;

        .userInfo {
            // margin-top: 10px;

            .user {
                .attention-phone {
                    display: none;
                }
                .attention{
                    display: none;
                }

                .btn,.btn-pc {
                    height: 30px;
                    line-height: 30px;
                    padding: 0 15px;
                    background: #FFFFFF;
                    border-radius: 18px;
                    border: 1px solid #333333;
                    text-align: center;
                    display: flex;
                    align-items: center;

                    >div {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        font-style: normal;
                    }
                }
                .btn-pc{
                    height: 40px;
                    border-radius: 20px;
                    cursor: pointer;
                }
                .btn{
                    display: none;
                }
            }
        }
    }
@media (max-width: 768px) {
    .phone {
        display: block !important;
    }

    .no-info {
        padding-top: 50px;
        display: block;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        >img {
            width: 34px;
            height: 25px;
        }

        >div {
            padding: 10px 40px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #333333;
            line-height: 17px;
            text-align: center;
            font-style: normal;
        }
    }
    .no-info-pc{
        display: none;
    }
    .userDetailPage {
        height: 100%;
        .top {
            width: 100%;
            margin: 0 auto;
        }

        .userInfo {
            background: #fff;
            padding: 20px 15px 20px;
            margin: 50px 0 10px;

            .user {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .userimg {

                    width: 58px;
                    height: 48px;

                    .avatar {
                        width: 48px;
                        /* 设置头像的宽度 */
                        height: 48px;
                        /* 设置头像的高度 */
                        border-radius: 5px;
                        /* 使头像呈现圆形 */
                    }

                    .username {
                        margin-left: 10px;
                        font-size: 16px;
                    }


                }

                .user-info {
                    flex: 1;

                    .username {
                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        line-height: 21px;
                        text-align: left;
                        font-style: normal;
                    }

                    .rating-collection {
                        display: flex;
                        align-items: center;
                        color: #FC7702;
                        margin-top: 6px;

                        .el-rate {
                            display: none;
                        }

                        .el-rate-phone {
                            display: block;
                            width: 20px;
                            height: 20px;
                        }

                        .fans {
                            font-size: 12px;
                        }
                    }
                }

                .introduce {
                    display: none;
                }

                .num {
                    padding-top: 10px;
                    font-size: 14px;
                    display: flex;
                    justify-content: flex-start;
                    // justify-content: space-between;
                    // padding-right: 15px;

                    a {
                        display: flex;
                        // flex-direction: column;
                        // align-items: center;
                    }
                }

                .attention {
                    display: none;

                }

                .attention-phone {
                    display: block;

                    .focuson {
                        width: 28px;
                        height: 28px;
                        margin-left: 6px;


                        // font-weight: 600;
                    }


                }

                .telegrams {
                    display: flex;
                    position: fixed;
                    bottom: 200px;
                    right: 10px;
                    z-index: 10;

                    flex-direction: column;

                    .telegram-icon {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                    }

                    .icon1 {
                        margin-right: 0px;
                        margin-bottom: 10px;
                    }
                }



            }
        }

        .list {
            background: #fff;

            padding: 10px 15px;
            .no-info-line{
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FC3938;
                line-height: 15px;
                font-style: normal;
                padding-top: 10px;
                padding-bottom: 20px;
                >img{
                    display: block;
                    width: 17px;
                    height: 17px;
                    margin-right: 7px;
                }
            }
            .goods-list {
                .body {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;

                    .item-none {
                        width: calc(50% - 5px);

                    }
                }
            }
        }
    }

    .no-pg {
        background-color: #F0F2F3;

        .userInfo {
            margin-top: 10px;

            .user {
                .attention-phone {
                    display: none;
                }

                .btn{
                    display: block;
                }
                .btn-pc{
                    display: none;
                }
            }
        }
    }
}
</style>